import { useEffect } from 'react';
import { useDrawerStore } from '@/stores/drawer';
import { cx } from '@/utils/cx';
import { IconButton } from '@/components/atoms/IconButton';

export const Drawer = () => {
  const open = useDrawerStore((s) => s.open);
  const config = useDrawerStore((s) => s.config);
  const close = useDrawerStore((s) => s.close);

  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') close();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, close]);

  return (
    <>
      <div className={cx('scrim', open && 'open')} onClick={close} aria-hidden="true" />
      <aside
        className={cx('drawer', open && 'open')}
        role="dialog"
        aria-hidden={!open}
        aria-label={config?.title}
      >
        <div className="drawer-head">
          <h3>{config?.title}</h3>
          <IconButton icon="x" label="Fechar" onClick={close} className="x" />
        </div>
        <div className="drawer-body">{config?.body}</div>
        {config?.foot && <div className="drawer-foot">{config.foot}</div>}
      </aside>
    </>
  );
};
